export default "__VITE_ASSET__CNxxn1tc__"